import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddOn } from '@compumark/analyst-selection-tool-client';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GridApi, GridOptions } from 'ag-grid-community';
import { debounceTime, fromEvent } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-wcl-addon-dialog',
  standalone: false,
  templateUrl: './wcl-addon-dialog.component.html',
  styleUrls: ['./wcl-addon-dialog.component.scss'],
})
export class WCLAddonDialogComponent {
  gridApi!: GridApi;

  readonly gridOptions: GridOptions = {
    suppressHeaderFocus: true,
    getRowId: (t) => t.data.url,
    rowModelType: 'clientSide',
    enableCellTextSelection: true,
    suppressHorizontalScroll: false,
    suppressMovableColumns: true,
    suppressCellFocus: true,
    suppressRowClickSelection: true,
    detailRowAutoHeight: true,
    headerHeight: 35,

    columnDefs: [
      {
        headerName: 'URL',
        field: 'url',
        wrapText: true,
        autoHeight: true,
        cellStyle: {
          'white-space': 'normal',
          'word-break': 'break-word',
          'line-height': '1.4',
        },
        sortable: false,
        filter: false,
        menuTabs: [],
      },
      {
        headerName: 'Type',
        field: 'type',
        wrapText: true,
        autoHeight: true,
        cellStyle: {
          'white-space': 'normal',
          'word-break': 'break-word',
          'line-height': '1.4',
        },
        sortable: false,
        filter: false,
        menuTabs: [],
      },
    ],

    onGridReady: (event) => {
      this.gridApi = event.api;

      this.gridApi.setGridOption('rowData', this.data.addOn.urls!);

      event.api.sizeColumnsToFit();

      fromEvent(window, 'resize')
        .pipe(untilDestroyed(this), debounceTime(250))
        .subscribe(() => {
          event.api.sizeColumnsToFit();
        });
    },
  };

  constructor(
    public dialogRef: MatDialogRef<WCLAddonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { addOn: AddOn },
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
